// Volume pricing shown to the buyer. Stripe holds the same tiers and is the authority on what is
// actually charged — this only makes the total honest before they get there.

export const unitPence = (plan, annual, seats) => {
  const tiers = annual ? null : plan.volume_tiers_monthly;
  if (!tiers || !tiers.length) {
    return Math.round((annual ? plan.price_annual : plan.price_monthly) * 100);
  }
  const tier = tiers.find((t) => t.up_to === null || seats <= t.up_to);
  return (tier || tiers[tiers.length - 1]).unit_pence;
};

/** Total, list price and saving for a quantity. Annual is billed for twelve months up front. */
export const quote = (plan, annual, requestedSeats) => {
  const seats = Math.max(requestedSeats, plan.min_seats || 1);
  const months = annual ? 12 : 1;
  const perSeat = unitPence(plan, annual, seats);
  const listPerSeat = Math.round((annual ? plan.price_annual : plan.price_monthly) * 100);
  const total = (perSeat * seats * months) / 100;
  const list = (listPerSeat * seats * months) / 100;
  // The tier this quantity actually falls into — not merely the first discounted one, or a small
  // buyer would be shown a discount badge with a £0 saving.
  const tiers = annual ? [] : plan.volume_tiers_monthly || [];
  const tier = tiers.find((t) => t.up_to === null || seats <= t.up_to);
  return {
    seats,
    total,
    perSeat: perSeat / 100,
    saving: annual ? 0 : list - total,
    discountPct: annual || !tier ? 0 : tier.discount_pct,
  };
};

export const money = (value) =>
  `£${value.toLocaleString(undefined, {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
